import {useParams} from 'react-router'
import {goBack} from '~/routing/actions'
import {Select, LegacyFormModal, Message, EitjeButton} from '~/components'
import {Invoice} from '@eitje/api'
import {ftime, prettyPrintArray} from '@eitje/utils'
import {t} from '~/initializers/i18n'
import {ResourceFetcher} from '~/services'
import {useState, useEffect} from 'react'
import {useFieldValue} from '@eitje/form'

export const EditInvoice = () => {
	const {id} = useParams()
	const invoice = Invoice.useFind(id, {joins: ['organisations', 'environments']})
	const [selectedStatus, setSelectedStatus] = useState(null)

	if (!invoice) return <ResourceFetcher id={id} kind="invoices" />

	const {status, billing_date, organisation, total_amt, environments, formatted_invoice_number, pdf, update} = invoice

	const statusses = ['paid', 'disregard', 'pending', status].uniq().filter(Boolean)
	const statusItems = statusses.map(id => ({id, t: `invoices.status.${id}`}))

	const getMessageKey = () => {
		const count = environments.length ?? 0
		const key = count === 0 ? 'no_envs' : count === 1 ? 'single_env' : 'multiple_envs'
		return `modals.edit_invoice.message_${key}`
	}

	const confirmText = ['paid', 'disregard'].includes(selectedStatus ?? status) ? 'hide_invoice' : 'show_invoice'

	return (
		<LegacyFormModal
			name="edit_invoice"
			onSubmit={params => update(params)}
			afterSubmit={goBack}
			modalProps={{
				title: t('modals.edit_invoice.title', {formatted_invoice_number}),
				confirmSubmit: true,
				okButtonProps: {
					t: 'common.save',
					iconLeft: 'checked',
					confirmText: {t: `modals.edit_invoice.confirm_message_${confirmText}`},
					confirmButtonProps: {t: 'common.save', iconLeft: null},
				},
				buttons: <EitjeButton iconLeft="download" t="common.invoice" target="_blank" externalLink={pdf} disabled={!pdf} />,
			}}
			initialValues={{status}}
			width={400}
		>
			<Message
				mdT={[
					getMessageKey(),
					{
						organisation_name: organisation.name,
						total_amt,
						billing_date: ftime(billing_date, 'relativeToDate'),
						environment_names: prettyPrintArray({array: environments._map('naam'), quotes: false, joinWord: '&'}),
					},
				]}
			/>
			<SyncStatusToParent onStatusChange={setSelectedStatus} />
			<Select field="status" items={statusItems} required />
		</LegacyFormModal>
	)
}

const SyncStatusToParent = ({onStatusChange}) => {
	const status = useFieldValue('status')
	useEffect(() => {
		onStatusChange?.(status)
	}, [status, onStatusChange])
	return null
}
